module.exports = __webpack_public_path__ + "img/temp-about-img1.763a4a7d.jpg";